import React from 'react'

export default function StudentDataRow({fullName, composite, english, math, reading, science}) {
  return (
    <tr className="studentData">
      <td className="name">{fullName}</td>
      <td className="score composite">{composite}</td>
      <td className="score english">{english}</td>
      <td className="score math">{math}</td>
      <td className="score reading">{reading}</td>
      <td className="score science">{science}</td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/ScoresByStudent/StudentDataRow.js